export default __webpack_public_path__ + "static/kb_1_4-9a83e6668d31ba799f817691829134f1.jpeg";